import type { MarketplaceKey } from "@porsche-customer/slfinrtl-context-types"
import { useCallback } from "react"
import type { MessageDescriptor } from "react-intl"
import { useIntl } from "react-intl"
import { newsEditorMessages as messages } from "../../components/newsEditor.messages"

// Not ISO 3166 regions, so Intl.DisplayNames cannot name them (XA even resolves to "Pseudo-Accents")
const nonIsoMarketplaceMessages: Partial<Record<MarketplaceKey, MessageDescriptor>> = {
	xa: messages.marketplaceAbuDhabi,
	xd: messages.marketplaceDubai,
	xp: messages.marketplacePorscheWerkswagen,
}

export const useMarketplaceName = (): ((marketplaceKey: MarketplaceKey) => string) => {
	const { formatDisplayName, formatMessage } = useIntl()

	return useCallback(
		(marketplaceKey) => {
			const nonIsoMessage = nonIsoMarketplaceMessages[marketplaceKey]
			return nonIsoMessage
				? formatMessage(nonIsoMessage)
				: (formatDisplayName(marketplaceKey.toUpperCase(), { type: "region" }) ?? marketplaceKey.toUpperCase())
		},
		[formatDisplayName, formatMessage],
	)
}
